module.exports = __webpack_public_path__ + "static/img/diyiimg3.48ec9c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyiimg3.png
// module id = Dysj
// module chunks = 5